/**
 * Version check utility to automatically reload the app when a new version is detected
 */

let versionCheckInterval = null;
let currentVersion = null;
let updateDetected = false;
const VERSION_STORAGE_KEY = "app_version";

export const isUpdateAvailable = () => updateDetected;

export const startVersionCheck = () => {
  // Check version more frequently for better responsiveness
  const CHECK_INTERVAL = 30 * 1000; // 30 seconds

  const checkVersion = async () => {
    try {
      // Use cache-busting query parameter and ensure no cache
      const timestamp = Date.now();
      const response = await fetch(
        `/version.json?v=${timestamp}&t=${timestamp}`,
        {
          cache: "no-store",
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );

      if (!response.ok) {
        return; // Silently fail if version.json doesn't exist
      }

      const data = await response.json();
      const newVersion = `${data.version}-${data.buildTime}`;

      // Get stored version from localStorage
      const storedVersion = localStorage.getItem(VERSION_STORAGE_KEY);

      if (currentVersion === null) {
        // First check - use stored version or current version
        currentVersion = storedVersion || newVersion;
        localStorage.setItem(VERSION_STORAGE_KEY, currentVersion);
      }

      if (currentVersion !== newVersion) {
        console.log("New version detected:", {
          old: currentVersion,
          new: newVersion,
        });
        currentVersion = newVersion;
        updateDetected = true;
        localStorage.setItem(VERSION_STORAGE_KEY, newVersion);
        window.dispatchEvent(new CustomEvent("appUpdateAvailable"));
      }
    } catch (error) {
      // Silently fail - don't break the app if version check fails
      console.debug("Version check failed:", error);
    }
  };

  // Check immediately on load
  checkVersion();

  // Then check periodically
  versionCheckInterval = setInterval(checkVersion, CHECK_INTERVAL);

  // Also check when page becomes visible (user switches back to tab)
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      checkVersion();
    }
  });

  // Check on window focus
  window.addEventListener("focus", checkVersion);
};

export const stopVersionCheck = () => {
  if (versionCheckInterval) {
    clearInterval(versionCheckInterval);
    versionCheckInterval = null;
  }
};
